import { finectAPI } from '@finect/front-utils/finectAPI';
export function setImpersonationToken(user, token) {
  return {
    type: 'SET_ADVISOR_IMPERSONATION_TOKEN',
    user: user,
    token: token
  };
}
export function clearImpersonationToken() {
  return {
    type: 'CLEAR_ADVISOR_IMPERSONATION_TOKEN'
  };
}
export function getImpersonationToken(user, cookie) {
  return function (dispatch) {
    return finectAPI({
      version: 'login',
      path: "sso/impersonate/".concat(user),
      method: 'GET',
      credentials: cookie,
      onSuccess: function onSuccess(_ref) {
        var data = _ref.data;
        dispatch(setImpersonationToken(user, data));
      },
      onError: function onError() {
        return console.log('ERROR in getImpersonationToken');
      }
    });
  };
}